/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHolidays } from 'packages/blu-booking/src/data_fetching/Holidays/Holidays';
import { RootState } from 'packages/blu-booking/src/store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Gestisce il data fetching del calendario Personal:
 * - Orari lavorativi per utente (calendar)
 * - Turni per utente (shift)
 * - Festività (holidays)
 * - Stato di loading aggregato
 *
 * Usa useDeferredValue per calendar e shift per evitare
 * che un cambio di dati blocchi il rendering del calendario.
 */
export function useSchedulerData() {
  const { loadingAppointments, appointments } = useSelector(
    (state: RootState) => state.bluBookingaAppointments
  );

  const { data: holidays, isLoading: isLoadingHolidays } = useHolidays();

  const isLoadingCalendarOrHolidays = useMemo(
    () => loadingAppointments || isLoadingHolidays,
    [loadingAppointments, isLoadingHolidays]
  );

  return {
    appointments,
    holidays,
    isLoadingCalendarOrHolidays,
  };
}
